/** DEFAULT_INPUT_DEBOUNCE_MS constant  */
export const DEFAULT_INPUT_DEBOUNCE_MS = 400;
/** DEFAULT_ACTIONS_DEBOUNCE_MS constant  */
export const DEFAULT_ACTIONS_DEBOUNCE_MS = 100;
/** DEFAULT_FORM_CHANGED_MS constant  */
export const DEFAULT_FORM_CHANGED_MS = 200;
/** DEFAULT_API_CHANGED_MS constant  */
export const DEFAULT_API_CHANGED_MS = 1000;
